import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { FlexBoxWrapper, Mt4, FullWidthJustifyEndWrapper, ReversedFlexboxWrapper } from 'wrappers';
import NoteMessage from '../noteMessage';

export const definition = {
  name: 'Note',
  controller: Controller,
  initialProps: ({ event, acceptDocuments, personsToMention, displayBottom }) => ({ event, currentUser: window.current_user, acceptDocuments, personsToMention, displayBottom }),
  props: internalState,
  elements: [
    {
      component: wrap(wrap(NoteMessage, FlexBoxWrapper), Mt4),
      name: 'OtherUserMessage',
      renderIf: ({ event, currentUser }) => currentUser !== event.created_by,
      displayState: ({ event, currentUser }) => ({ hasImage: !!event.src, right: currentUser === event.created_by }),
      bindings: ({ event, currentUser, acceptDocuments, personsToMention, displayBottom }) => ({ event, currentUser, personsToMention: [], acceptDocuments, personsToMention, displayBottom })
    },
    {
      component: wrap(wrap(NoteMessage, ReversedFlexboxWrapper), FullWidthJustifyEndWrapper),
      name: 'CurrentUserMessage',
      renderIf: ({ event, currentUser }) => currentUser === event.created_by,
      displayState: ({ event, currentUser }) => ({ hasImage: !!event.src, right: currentUser === event.created_by }),
      bindings: ({ event, currentUser, acceptDocuments, personsToMention, displayBottom }) => ({ event, currentUser, personsToMention: [], acceptDocuments, personsToMention, displayBottom })
    }
  ]
};

const Note = ContainerComponent(definition);

export default Note;
